import { Image, Modal } from '@tryhackme/thm-ui-components';
import { SocialName } from 'src/common/page-share';
import { StyledImageWrapper, StyledModalContent } from './badge-share-modal.styles';
import { BadgeShareModalSocialSharing } from './badge-modal-social-share';
export interface BadgeShareModalProps {
  description: string;
  image: string;
  name: string;
  title: string;
  username: string;
  earnedAt?: string;
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  userBadges: {
    name: string;
    earnedAt?: string;
  }[];
}
export const BadgeShareModal = ({
  description,
  image,
  name,
  title,
  username,
  earnedAt,
  isModalOpen,
  setIsModalOpen,
  userBadges
}: BadgeShareModalProps) => {
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const userBadgeNames = userBadges.map(badge => badge.name);
  const isEarned = userBadgeNames.includes(name);
  const getEarnedStatus = () => {
    if (isEarned) {
      if (earnedAt) {
        return `Earned on ${new Date(earnedAt).toLocaleDateString('en-US', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })}`;
      }
      return 'Earned';
    }
    return 'Not earned';
  };
  return <Modal onOpenChange={handleCloseModal} open={isModalOpen} padding="3rem 3rem" data-sentry-element="Modal" data-sentry-component="BadgeShareModal" data-sentry-source-file="badge-share-modal.tsx">
      <StyledModalContent data-sentry-element="StyledModalContent" data-sentry-source-file="badge-share-modal.tsx">
        <StyledImageWrapper $isEarned={isEarned} data-sentry-element="StyledImageWrapper" data-sentry-source-file="badge-share-modal.tsx">
          <Image src={image} alt={name} loading="lazy" data-sentry-element="Image" data-sentry-source-file="badge-share-modal.tsx" />
        </StyledImageWrapper>
        <h2>{title}</h2>
        <p>{description}</p>

        <p>{getEarnedStatus()}</p>

        {isEarned && <BadgeShareModalSocialSharing username={username} badgeName={name} socialLinks={{
        [SocialName.facebook]: true,
        [SocialName.linkedin]: true,
        [SocialName.twitter]: true
      }} />}
      </StyledModalContent>
    </Modal>;
};